//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Row, Col, Icon } from "vant";
import { Cell, CellGroup } from "vant";
import { Step, Steps } from "vant";
import { Button } from "vant";
import { Panel } from "vant";
import { Collapse, CollapseItem } from "vant";
import $manager from "@/Manager/12.Mes/ProductDataInAddOrderManager";


export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Panel.name]: Panel,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  data() {
    return {
      stepIndex: 0,

      ThisProductName: "",
      ThisProductItem: {},

      ProductSpec: 6,

      PackDate: "",
      PackDateExt: new Date().getDate(),
      PackDateExtMinDate: new Date(2019, 1, 1),
      PackDateExtMaxDate: new Date(2020, 10, 1),

      showPackDatePicker: false,
      showProductPicker: false,

      ProductDataList: [],
      ProductColumnNameList: [],

      activeNames: [],

      ThisProductBsn: "",

      ThisProductSnList: [],

      ProductBsnList: []
    };
  },
  async created() {

    this.$wx.initConfig();

    await this.loadProductData();

    var now = new Date();
    this.PackDate = this.$to.date2String(now);
    console.log(this.PackDate);
  },

  watch: {
    
  },

  mounted() {},
  methods: {
    onBackClick() {
      switch (this.stepIndex) {
        case 0: {
          break;
        }
        case 1: {
          this.stepIndex--;
          break;
        }
        case 2: {
          this.stepIndex--;
          break;
        }
      }
    },
    onNextClick1() {
      if (!this.ThisProductName) {
        this.$msg.error("请选择产品.");
        return;
      }

      if (!this.PackDate) {
        this.$msg.error("请指定生产日期.");
        return;
      }

      console.log("onNextClick1");
      this.stepIndex = 1;

      this.ProductSpec = this.ThisProductItem.BoxSpec;
      this.resetThisData();
    },

    resetThisData() {
      this.ThisProductBsn = "";
      this.ThisProductSnList = new Array(this.ProductSpec);
      for (var i = 0; i < this.ProductSpec; i++) {
        var snItem = "";
        this.$set(this.ThisProductSnList, i, snItem);
      }
      //this.$set(this.ThisProductSnList,3,"222");
      console.log("onNextClick--ThisProductSnList", this.ThisProductSnList);
    },

    async loadProductData() {
      this.$msg.showLoading();

      var result  = await $manager.getProductData();
      if(result && result.state == 1){
        this.ProductDataList = result.data.DataList;
        this.ProductColumnNameList = result.data.ColumnNameList;
      }      
      this.$msg.hideLoading();
    },

    onProductConfirm(value, index) {
      console.log(value);
      this.ThisProductName = value;
      this.ThisProductItem = null;

      if (index >= 0) {
        this.ThisProductItem = this.ProductDataList[index];
      }
      console.log("this.ThisProductItem ", this.ThisProductItem);
      this.showProductPicker = false;
    },

    onPackDateClick() {
      this.showPackDatePicker = true;
      if (this.PackDate) {
        this.PackDateExt = this.$to.string2Date(this.PackDate);
      }
    },

    onPackDateConfirm(value) {
      console.log(value);
      this.PackDate = this.$to.date2String(value);
      this.showPackDatePicker = false;
    },

    //===========step 2============================

    onScanBsnCodeClick(vModel,codeType){
      console.log("vModel:",vModel);

      this.$wx.scanCode((scanCode)=>{
        this.ThisProductBsn = scanCode;
        console.log("onScanBsnCodeClick--scanCode:",scanCode);
      });   

    },

    onScanSnCodeClick(snIndex,vModel,codeType){
      console.log("snIndex",snIndex);

      this.$wx.scanCode((scanCode)=>{

        this.$set(this.ThisProductSnList, snIndex, scanCode);

      });      
    },

    ///用于解决vue不能主动监听数组input事件的问题。
    onInputProductSn(value, snIndex, snItem) {

      this.ThisProductSnList[snIndex] = value;

    },

    onAddProductBsnList() {
      if (!this.ThisProductBsn) {
        this.$msg.error("箱码不能为空.");
        return;
      }

      for (var i = 0; i < this.ThisProductSnList.length; i++) {
        if (!this.ThisProductSnList[i]) {
          this.$msg.error("单品码不能为空.");
          return;
        }
      }

      console.log("this.ThisProductSnList", this.ThisProductSnList);
      var newBsnItem = {
        Bsn: JSON.parse(JSON.stringify(this.ThisProductBsn)),
        SnList: JSON.parse(JSON.stringify(this.ThisProductSnList))
      };
      this.ProductBsnList.push(newBsnItem);
      console.log("this.ProductBsnList", this.ProductBsnList);
      //console.log("productBsnItem",newBsnItem);
      this.resetThisData();

      this.$msg.succ("操作成功");
    },

    onNextClick2() {
      console.log("onNextClick2");

      if (!this.ProductBsnList || this.ProductBsnList.length == 0) {
        this.$msg.error(
          "当前没有关联的箱码数据，请先添加要箱码列表中，再进行下一步."
        );
        return;
      }

      this.stepIndex = 2;
    },

    //===========step 3============================

    submitOrder() {
      if (!this.ProductBsnList || this.ProductBsnList.length == 0) {
        this.$msg.error(
          "当前没有关联的箱码数据，请先添加要箱码列表中，再进行下一步."
        );
        return;
      }

      this.$msg.confirm("是否要提交单据?",async ()=>{
        
        var postData = {
          ProductName: this.ThisProductName,
          ProductOpenId: this.ThisProductItem.OpenId,

          PackDate: this.PackDate,
          ProductBsnList: this.ProductBsnList
        };

        this.$msg.showLoading("正在提交单据...");
        var result =  await $manager.submitData(postData);
        this.$msg.hideLoading();

        this.$msg.succ(result.msg);

        var url = "/Mes/ProductDataInAddOrder/End?openId=" +result.data.OpenId;
        this.$router.push(url);


      });

      
    }
  }
};
